import { toast } from 'react-toastify'

export const notifyError = (message: string | JSX.Element) => toast.error(message)

export const Notification = { notifyError }
